import { useContext } from 'react';

import { AuthContext } from '@providers/auth';
import { GoogleMapsContext } from '@providers/googleMaps';
import { SiteContext } from '@providers/site';

export const useSiteContext = () => useContext(SiteContext);
export const useAuthContext = () => useContext(AuthContext);
export const useGoogleMapsContext = () => useContext(GoogleMapsContext);
